/*
 * @Author: your name
 * @Date: 2021-09-20 10:54:02
 * @LastEditTime: 2021-12-26 15:55:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\i18n\lang\en\index.js
 */
import enLocale from 'element-ui/lib/locale/lang/en'

export default {
  Index: {
    wallet: 'Connect Wallet',
    connet: 'Please Connect Wallet',
    Quit: 'Quit',
    title1: 'Earn',
    title2: 'Bounties',
    title3: 'By Doing Tasks',
    getStart: 'Get Started',
    donotHave: 'Don’t have a wallet yet?',
    copyRight: '© 2021 Conflux. All Rights Reserved. Terms Privacy | Policy',
    header: {
      walletTip: 'Wallet not installed'
    },
    footer: {
      FAQs: 'FAQs',
      Conflux: 'Conflux',
      Explorer: 'Explorer',
      Wallet: 'Wallet',
      BountyV1: 'Bounty V1',
      Help: 'Help'
    },
    bannerDes1: 'Guide on how to use Bounty',
    bannerDes2: 'Verify your identity on PandaID to get CFX'
  },
  Router: {
    Skills: 'Skills',
    HotTask: 'Hot Tasks',
    AllTask: 'All Tasks',
    Projects: 'Projects'
  },
  Skills: {
    title: 'Skills',
    description: 'Acquire skills to qualify for more quests.',
    backDes: 'All Skills',
    startTask: 'Start the Task',
    helpDescription: 'A skill is an on-chain credential that signals your knowledge about a given topic or product.',
    skilPandaId: {
      tip: 'The system detects that the identity of your Panda ID has not been verified. Click to complete identity verification.',
      tip2: 'The system detects that the identity of your Panda ID has not been verified.',
      No: 'No',
      Yes: 'Yes'
    },
    skilPortal: {
      tip: 'Wallet Not Connected.',
      No: 'No',
      Yes: 'Yes'
    },
    skillListTip: {
      tipPortal: 'Install Portal',
      desPortal: 'Install Portal Wallet',
      tipPandaId: 'Install Panda ID',
      desPandaId: 'Already binded Panda ID?',
      checkNow: 'Check'
    }
  },
  HotTask: {
    title: 'Hot Tasks',
    description: 'Acquire skills to qualify for more quests.',
    all: 'All',
    personal: 'Personal',
    project: 'Project',
    backDes: 'Hot Tasks',
    titleDetail: 'Task',
    descriptionDetail: 'Get started with PoolGo.',
    taskStatus: ['ongoing', 'upcoming', 'finished'],
    Rewards: 'Rewards',
    Remaining: 'Remaining',
    rewardsRemaining: 'rewards remaining',
    totalRewards: 'Total Rewards',
    issued: 'Checked',
    participants: 'Participants',
    Ends: 'Ends ',
    detail: {
      Description: 'Description',
      AcceptanceCriteria: 'Acceptance Criteria',
      ContactInformation: 'Contact information',
      About: 'About ',
      HoursLeft: ' Hours Left'
    },
    StartTask: 'Start the Task',
    NoData: 'No Data'
  },
  planDialog: {
    RejectReason: 'Reason',
    ProgrammeDetails: 'Solution Description',
    Completion: 'Completion',
    CompleteAttachment: 'Complete Attachment',
    Cancel: 'Cancel',
    Submit: 'Submit',
    SubmitToCheck: 'Submit to check'
  },
  AllTask: {
    title: 'All Tasks',
    description: 'Acquire skills to qualify for more quests.',
    backDes: 'All Tasks',
    searchPlaceholder: 'Search by task number or keyword',
    TotalReward: 'Total Rewards: ',
    taskStatus: {
      Ongoing: 'Ongoing',
      Upcoming: 'Upcoming',
      Finished: 'Finished'
    }
  },
  ...enLocale,
  My: {
    My: 'My',
    BountyName: 'Bounty name',
    EditProfile: 'Edit Profile',
    Nickname: 'Nickname',
    PandaID: 'Panda ID',
    Email: 'Email',
    PandaState: 'Panda State',
    IdentityCategories: 'Identity categories',
    NoteInformation: 'Profile',
    HeadPortrait: 'Profile Picture',
    Save: 'Save',
    message: {
      title: 'Message',
      subTitle: 'Message',
      removeUnread: 'Remove Unread',
      ClearAllNotice: 'Clear All Notice',
      yes: 'Yes',
      cancel: 'Cancel'
    },
    project: {
      CreationTime: 'Creation Time:'
    },
    loading: 'Uploading...',
    approving: 'In authorization',
    approveBtn: 'Approve',
    view: 'View'
  },
  MyList: {
    MyProject: 'My Project',
    publishedTasks: 'Published Tasks',
    receivedScheme: 'Received Scheme',
    submittedProposal: 'Submitted Proposal',
    MissionName: 'Mission Name',
    ReleaseTime: 'Release Time',
    TheNumberOfparticipants: 'The number of participants',
    Operate: 'Operate',
    Edit: 'Edit',
    Delete: 'Delete',
    CreateTask: 'Create Task',
    newProject: 'New Project'
  },
  ProjectTask: {
    PublishedTasks: 'Published Tasks',
    Project: 'Project',
    TotalRewards: 'Total Rewards',
    TaskNature: 'Task Nature',
    PaymentTokensId: 'PaymentTokensId',
    NFTContractAddress: 'NFT Contract Address',
    CreateProject: 'Create Project',
    CreateABountyTask: 'Create a Bounty Task',
    TaskSubject: 'Task Subject',
    TaskType: 'Task Type',
    Country: 'Country/Region',
    ActivityDate: 'Activity Date',
    TotalReward: 'Total Rewards',
    TheNumberOfParticipants: 'The number of participants',
    AcceptanceCriteria: 'Acceptance Criteria',
    TaskDescribe: 'Task Description',
    ContactInformation: 'Contact information',
    ConfirmRelease: 'Confirm Release',
    startTime: 'Start Time',
    to: 'to',
    endTime: 'End Time',
    selectPlaceholder: 'Please Choose',
    tipDialog: 'The bounty task once submitted will enter the reviewing state of the system and cannot be modified.',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  Project: {
    Projects: 'Projects',
    backDes: 'Projects',
    CreateProject: 'Create Project',
    MyProject: 'My Project',
    ProjectName: 'Project Name',
    ProjectType: 'Project Type',
    ProjectDescription: 'Project Description',
    ProjectURL: 'Project URL',
    LOGOUpload: 'LOGO Upload',
    Next: 'Next',
    Confirm: 'Save',
    Yes: 'Yes',
    Cancel: 'Cancel',
    Remove: 'Remove '
  },
  Task: {
    CreateABountyTask: 'Create a Bounty Task',
    TaskSubject: 'Task Subject',
    TotalReward: 'Total Rewards',
    TaskType: 'Task Type',
    TheNumberOfParticipants: 'The number of participants',
    TaskDescribe: 'Task Description',
    AcceptanceCriteria: 'Acceptance Criteria',
    ActivityDate: 'Activity Date',
    EstimatedRewardTime: 'Estimated reward time',
    ContactInformation: 'Contact information',
    ConfirmRelease: 'Confirm Release',
    selectPlaceholder: 'Please Choose',
    startTime: 'Start Time',
    endTime: 'End Time',
    list: {
      countAll: 'countAll',
      countTobechecked: 'countTobechecked',
      countChecked: 'countChecked'
    },
    taskStatus: {
      temp: 'Temp',
      review: 'Review',
      back: 'Failed',
      ongoing: 'Ongoing',
      upcoming: 'Upcoming',
      finished: 'Finished',
      close: 'Close'
    }
  },
  Proposal: {
    status: {
      all: 'all',
      tobechecked: 'tobechecked',
      checked: 'checked',
      temp: 'temp',
      doing: 'doing',
      unchecked: 'unchecked',
      payed: 'payed',
      close: 'close'
    },
    BatchPass: 'Batch Pass',
    BatchNoPass: 'Batch No Pass',
    BatchPay: 'Batch Pay',
    Export: 'Export',
    SelectAll: 'SelectAll',
    CompletionDate: 'Completion Date:',
    pass: 'pass',
    nopass: 'no pass',
    Pay: 'Pay',
    dateOfProposal: 'Date of proposal'
  },
  allTip: {
    tip1: 'Please Choose',
    tip2: 'Please input solution description',
    tip3: 'Please input completion',
    tip4: 'Searching...',
    tip5: 'Please Connect Wallet',
    tip6: 'Please upload files in JPG, PNG or BMP format.',
    tip7: 'Replication failed',
    tip8: 'Plese input project name',
    tip9: 'Plese select project type',
    tip10: 'Plese input project description',
    tip11: 'Plese select logo',
    tip12: 'Plese select task subject',
    tip13: 'Plese select task type',
    tip14: 'Plese pick activity date',
    tip15: 'Please input total rewards',
    tip16: 'Plese input digit',
    tip17: 'Plese input number',
    tip18: 'Plese input digit',
    tip19: 'Total rewards must divided exactly by the number of participants',
    tip20: 'Plese select task nature',
    tip21: 'Plese select task description',
    tip22: 'Get back success',
    tip23: 'NFT Contract Address Must Input',
    tip24: 'In the submission',
    tip25: 'Plese select token type',
    tip26: 'Please input reason of reject',
    tip27: 'The two login addresses are inconsistent',
    tip28: 'Task was successfully received, please go to the personal home page - submitted proposal to complete the task and submit the proposal.'
  }
}
